export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkEnv: 'production',
    sdkVersion: '1.12.6',
};
//# sourceMappingURL=buildEnv.js.map